import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import AllReviewsTab from './AllReviewsTab';
import ByOrderTab from './ByOrderTab';

const Reviews = () => {
    const [tab, setTab] = useState('all');

    return (
        <div className="p-4 sm:p-6 lg:p-8">
            <h1 className="text-3xl font-bold mb-6">Reviews & Ratings</h1>

            <Tabs value={tab} onValueChange={setTab} className="w-full">
                <TabsList className="grid grid-cols-2 max-w-md mb-6">
                    <TabsTrigger value="all" data-testid="reviews-tab-all">All Reviews</TabsTrigger>
                    <TabsTrigger value="byOrder" data-testid="reviews-tab-by-order">By Order</TabsTrigger>
                </TabsList>

                <TabsContent value="all"><AllReviewsTab /></TabsContent>
                <TabsContent value="byOrder"><ByOrderTab /></TabsContent>
            </Tabs>
        </div>
    );
};

export default Reviews;
